import Home from "./views/Home.vue";
import Challenges from "./views/Challenges.vue";
import Sell from "./views/Sell.vue";
import Login from "./views/Login.vue";
import Welcome from "./views/Welcome.vue";
import Logout from "./components/Logout.vue";
import AdminExcelAssessments from "./components/AdminExcelAssessments.vue";
import Register from "./views/Register.vue";
import Community from "./views/Community.vue";
import Podcasts from "./views/Podcasts.vue";
import Podcast from "./views/Podcast.vue";
import CommunityListDiscussions from "./views/CommunityListDiscussions.vue";
import CommunityDiscussion from "./views/CommunityDiscussion.vue";
import PasswordReset from "./views/PasswordReset.vue";
import AssessmentWelcome from "./views/AssessmentWelcome.vue";
import Assessment from "./views/Assessment.vue";
import Course from "./views/Course.vue";
import Gaps from "./views/Gaps.vue";
import Slider from "./views/Slider.vue";
import Slider2 from "./views/Slider2.vue";
import Skills from "./views/Skills.vue";
import Profile from "./views/Profile.vue";
import ProfileEdit from "./views/ProfileEdit.vue";
import Team from "./views/Team.vue";
import TeamMember from "./views/TeamMember.vue";
import VideoPlayer from "./views/VideoPlayer.vue";
import Lab from "./views/Lab.vue";

import Admin from "./views/Admin.vue";
import HooperTest from "./views/HooperTest.vue";
import Sticky from "./views/Sticky.vue";

import SubscriberTermsAndConditions from "./views/SubscriberTermsAndConditions.vue";
import WebsiteTermsAndConditions from "./views/WebsiteTermsAndConditions.vue";
import PrivacyAndCookiePolicy from "./views/PrivacyAndCookiePolicy.vue";

/* admin */
import AdminDashboard from "./components/AdminDashboard";
import AdminProfiles from "./components/AdminProfiles";
import AdminVideos from "./components/AdminVideos";
import AdminVideosEdit from "./components/AdminVideosEdit";
import AdminProfilesEdit from "./components/AdminProfilesEdit";
import AdminCourses from "./components/AdminCourses";
import AdminCoursesEdit from "./components/AdminCoursesEdit";
import AdminPodcasts from "./components/AdminPodcasts";
import AdminPodcastsEdit from "./components/AdminPodcastsEdit";
import AdminMaps from "./components/AdminMaps";
import AdminBadGateway from "./components/AdminBadGateway";

const routes = [
  {
    path: "/register",
    name: "register",
    component: Register,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: "/login",
    name: "login",
    component: Login,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: "/welcome",
    name: "welcome",
    component: Welcome,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: "/logout",
    name: "logout",
    component: Logout,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/password-reset",
    name: "password-reset",
    component: PasswordReset,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: "/",
    name: "home",
    component: Home,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/challenges",
    name: "challenges",
    component: Challenges,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/sell",
    name: "sell",
    component: Sell,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/profile",
    name: "profile",
    component: Profile,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/profile/edit",
    name: "ProfileEdit",
    component: ProfileEdit,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/team",
    name: "Team",
    component: Team,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/team/member/:memberkey",
    name: "TeamMember",
    component: TeamMember,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/community",
    name: "community",
    component: Community,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/podcasts",
    name: "podcasts",
    component: Podcasts,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/podcast/:podcastid",
    name: "podcast",
    component: Podcast,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/community/community-list-discussions/:categoryname",
    name: "community-list-discussions",
    component: CommunityListDiscussions,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/community/community-discussion/:discussionfirebaseid",
    name: "community-discussion",
    component: CommunityDiscussion,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/assessment-welcome",
    name: "assessment-welcome",
    component: AssessmentWelcome,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/assessment",
    name: "assessment",

    component: Assessment,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/gaps",
    name: "gaps",
    component: Gaps,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/course/:courseslug",
    name: "course",
    component: Course,
    meta: {
      requiresAuth: true
    }
  },

  {
    path: "/course/:courseslug",
    name: "course",
    component: Course,
    meta: {
      requiresAuth: true
    }
  },

  {
    path: "/course/:courseslug",
    name: "course",
    component: Course,
    meta: {
      requiresAuth: true
    }
  },

  {
    path: "/slider",
    name: "slider",
    component: Slider,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/slider2",
    name: "slider2",
    component: Slider2,
    meta: {
      requiresAuth: true
    }
  },
  {
    //path: '/skills/:filledassessmentidrouterparam',
    path: "/skills",
    name: "skills",
    component: Skills,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/hooper-test",
    name: "hooper-test",
    component: HooperTest,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/sticky",
    name: "sticky",
    component: Sticky,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/lab",
    name: "lab",
    component: Lab,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/course/:courseslug/video-player/:videoid",
    name: "video-player",
    component: VideoPlayer,
    meta: {
      requiresAuth: true
    }
  },

  {
    path: "/about",
    name: "about",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "./views/About.vue")
  },

  {
    path: "/subscriber-terms-and-conditions",
    name: "subscriber-terms-and-conditions",
    component: SubscriberTermsAndConditions,
    meta: {
      requiresAuth: true
    }
  },

  {
    path: "/website-terms-and-conditions",
    name: "website-terms-and-conditions",
    component: WebsiteTermsAndConditions,
    meta: {
      requiresAuth: true
    }
  },

  {
    path: "/privacy-and-cookie-policy",
    name: "privacy-and-cookie-policy",
    component: PrivacyAndCookiePolicy,
    meta: {
      requiresAuth: true
    }
  },

  {
    path: "/admin",
    name: "admin",
    component: Admin,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: "/admin/dashboard",
        name: "AdminDashboard",
        component: AdminDashboard,
        props: { page: 1 }
      },
      {
        path: "/admin/profiles",
        name: "AdminProfiles",
        props: { page: 2 },
        component: AdminProfiles
      },
      {
        path: "/admin/profiles/edit/:profileid",
        name: "AdminProfilesEdit",
        props: { page: 2 },
        component: AdminProfilesEdit
      },
      {
        path: "/admin/maps",
        name: "AdminMaps",
        props: { page: 4 },
        component: AdminMaps
      },
      {
        path: "/admin/404",
        name: "AdminBadGateway",
        props: { page: 5 },
        component: AdminBadGateway
      },
      {
        path: "/admin/videos",
        name: "AdminVideos",
        props: { page: 3 },
        component: AdminVideos
      },
      {
        path: "/admin/excelassessments",
        name: "AdminExcelAssessments",
        props: { page: 6 },
        component: AdminExcelAssessments
      },
      {
        path: "/admin/videos/edit/:videoid",
        name: "AdminVideosEdit",
        props: { page: 3 },
        component: AdminVideosEdit
      },
      {
        path: "/admin/videos/add",
        name: "AdminVideosAdd",
        props: { page: 3 },
        component: AdminVideosEdit
      },
      {
        path: "/admin/courses",
        name: "AdminCourses",
        props: { page: 4 },
        component: AdminCourses
      },
      {
        path: "/admin/courses/edit/:courseid",
        name: "AdminCoursesEdit",
        component: AdminCoursesEdit
      },
      {
        path: "/admin/courses/add",
        name: "AdminCoursesAdd",
        component: AdminCoursesEdit
      },
      {
        path: "/admin/podcasts",
        name: "AdminPodcasts",
        props: { page: 4 },
        component: AdminPodcasts
      },
      {
        path: "/admin/podcasts/edit/:podcastid",
        name: "AdminPodcastsEdit",
        component: AdminPodcastsEdit
      },
      {
        path: "/admin/podcasts/add",
        name: "AdminPodcastsAdd",
        component: AdminPodcastsEdit
      }
    ]
  },

  {
    path: "*",
    props: { page: 5 },
    redirect: "/404"
  },
  {
    path: "/404",
    props: { page: 5 },
    redirect: "/404"
  }
  // { path: '/student/:id', component: Student }, -- parameter example; in template: Student ID is: {{ $route.params.id }}
  // see good reference: https://appdividend.com/2018/12/28/vue-router-tutorial-with-example-how-to-use-routing-in-vuejs/
];

export default routes;
